import React from "react";

export function Controls({ 
  playing, 
  onTogglePlay, 
  onSnapshot, 
  onFullscreen, 
  onTogglePip, 
  speed, 
  onSpeed, 
  presets, 
  onPreset,
  mode,
  onModeChange,
  videoFormat,
  onVideoFormatChange,
  isHovered = true,
  selectDropDown=true,
  quadView=true
}) {
  // Debug logging
  
  return (
    <div 
      className={`cam360-controls ${isHovered ? 'visible' : 'hidden'}`}
      style={{
        position: 'absolute',
        bottom: '12px',
        left: '50%',
        transform: `translateX(-50%) ${isHovered ? 'translateY(0)' : 'translateY(10px)'}`,
        display: 'flex',
        gap: '8px',
        background: 'rgba(0,0,0,0.85)',
        padding: '8px 16px',
        borderRadius: '28px',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255,255,255,0.2)',
        zIndex: 99,
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 24px rgba(0,0,0,0.5), 0 2px 8px rgba(0,0,0,0.3)',
        opacity: isHovered ? 1 : 0,
        transition: 'all 0.3s ease',
        height: '48px',
        width: 'auto',
        minWidth: 'fit-content',
        pointerEvents: isHovered ? 'auto' : 'none',
        boxSizing: 'border-box',
        overflow: 'hidden',
        flexWrap: 'nowrap'
      }}
    >
      <button 
        onClick={onTogglePlay}
        className="control-btn primary-btn"
        style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.85))',
          border: '2px solid rgba(255,255,255,0.4)',
          color: '#000',
          padding: '0',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: '18px',
          fontWeight: '600',
          transition: 'all 0.3s ease',
          boxShadow: '0 6px 16px rgba(0,0,0,0.5), 0 2px 6px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.3)',
          width: '36px',
          height: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.15)';
          e.target.style.boxShadow = '0 8px 20px rgba(0,0,0,0.6), 0 3px 8px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.4)';
          e.target.style.borderColor = 'rgba(255,255,255,0.6)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.5), 0 2px 6px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.3)';
          e.target.style.borderColor = 'rgba(255,255,255,0.4)';
        }}
      >
        {playing ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <rect x="6" y="4" width="4" height="16" rx="2" fill="currentColor"/>
            <rect x="14" y="4" width="4" height="16" rx="2" fill="currentColor"/>
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M8 5v14l11-7z" fill="currentColor"/>
          </svg>
        )}
      </button>
      
      {onSnapshot && (
        <button 
          onClick={onSnapshot}
          className="control-btn secondary-btn"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08))',
            border: '1px solid rgba(255,255,255,0.3)',
            color: 'white',
            padding: '0',
            borderRadius: '50%',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)',
                width: '28px',
                height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0.15))';
            e.target.style.transform = 'scale(1.08)';
            e.target.style.borderColor = 'rgba(255,255,255,0.5)';
            e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.5), 0 3px 6px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08))';
            e.target.style.transform = 'scale(1)';
            e.target.style.borderColor = 'rgba(255,255,255,0.3)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)';
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
            <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1" stroke="currentColor" strokeWidth="1" opacity="0.5"/>
          </svg>
        </button>
      )}
      
      {onFullscreen && (
        <button 
          onClick={onFullscreen}
          className="control-btn secondary-btn"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08))',
            border: '1px solid rgba(255,255,255,0.3)',
            color: 'white',
            padding: '0',
            borderRadius: '50%',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)',
                width: '28px',
                height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0.15))';
            e.target.style.transform = 'scale(1.08)';
            e.target.style.borderColor = 'rgba(255,255,255,0.5)';
            e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.5), 0 3px 6px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08))';
            e.target.style.transform = 'scale(1)';
            e.target.style.borderColor = 'rgba(255,255,255,0.3)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)';
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" fill="currentColor"/>
            <rect x="2" y="2" width="6" height="6" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.6"/>
            <rect x="16" y="16" width="6" height="6" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.6"/>
          </svg>
        </button>
      )}
      
      {onTogglePip && (
        <button 
          onClick={onTogglePip}
          className="control-btn secondary-btn"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08))',
            border: '1px solid rgba(255,255,255,0.3)',
            color: 'white',
            padding: '0',
            borderRadius: '50%',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)',
                width: '28px',
                height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0.15))';
            e.target.style.transform = 'scale(1.08)';
            e.target.style.borderColor = 'rgba(255,255,255,0.5)';
            e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.5), 0 3px 6px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08))';
            e.target.style.transform = 'scale(1)';
            e.target.style.borderColor = 'rgba(255,255,255,0.3)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)';
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <rect x="2" y="2" width="20" height="20" rx="2" fill="none" stroke="currentColor" strokeWidth="2"/>
            <rect x="6" y="6" width="12" height="8" rx="1" fill="currentColor" opacity="0.8"/>
            <rect x="8" y="16" width="8" height="4" rx="1" fill="currentColor" opacity="0.6"/>
            <circle cx="10" cy="18" r="1" fill="currentColor"/>
            <circle cx="14" cy="18" r="1" fill="currentColor"/>
          </svg>
        </button>
      )}

      {/* Video Format Toggle Button */}
      {onVideoFormatChange && (
        <button 
          onClick={() => onVideoFormatChange(videoFormat === '360' ? 'flat' : '360')}
          className="control-btn secondary-btn"
          style={{
            background: videoFormat === '360' ? 'linear-gradient(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0.15))' : 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08))',
            border: videoFormat === '360' ? '1px solid rgba(255,255,255,0.5)' : '1px solid rgba(255,255,255,0.3)',
            color: 'white',
            padding: '0',
            borderRadius: '50%',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: videoFormat === '360' ? '0 6px 16px rgba(0,0,0,0.5), 0 3px 6px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)' : '0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)',
                width: '28px',
                height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.3), rgba(255,255,255,0.2))';
            e.target.style.transform = 'scale(1.08)';
            e.target.style.borderColor = 'rgba(255,255,255,0.6)';
            e.target.style.boxShadow = '0 8px 20px rgba(0,0,0,0.6), 0 4px 8px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = videoFormat === '360' ? 'linear-gradient(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0.15))' : 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08))';
            e.target.style.transform = 'scale(1)';
            e.target.style.borderColor = videoFormat === '360' ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.3)';
            e.target.style.boxShadow = videoFormat === '360' ? '0 6px 16px rgba(0,0,0,0.5), 0 3px 6px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)' : '0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)';
          }}
          title={videoFormat === '360' ? 'Switch to Flat Video' : 'Switch to 360° Video'}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            {videoFormat === '360' ? (
              <>
                <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6l5.25 3.15-.75 1.23L11 13V7z" fill="currentColor"/>
                <circle cx="12" cy="12" r="2" fill="currentColor" opacity="0.6"/>
                <path d="M12 1v2m0 18v2m11-11h-2M1 12h2" stroke="currentColor" strokeWidth="1" opacity="0.4"/>
              </>
            ) : (
              <>
                <rect x="3" y="3" width="18" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="2"/>
                <rect x="6" y="6" width="12" height="8" rx="1" fill="currentColor" opacity="0.8"/>
                <rect x="8" y="16" width="8" height="2" rx="1" fill="currentColor" opacity="0.6"/>
                <rect x="8" y="19" width="4" height="1" rx="0.5" fill="currentColor" opacity="0.4"/>
                <rect x="13" y="19" width="3" height="1" rx="0.5" fill="currentColor" opacity="0.4"/>
              </>
            )}
          </svg>
        </button>
      )}

      {/* View Mode Toggle - Always show if onModeChange is provided */}
      {onModeChange &&  (
        <div style={{ 
          display: 'flex', 
          gap: '4px', 
          marginLeft: '8px',
          border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: '20px',
          padding: '4px',
          background: 'rgba(255,255,255,0.1)',
          backdropFilter: 'blur(12px)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
          position: 'relative',
          alignItems: 'center'
        }}>
          <button 
            onClick={() => {
              console.log('Single view button clicked');
              onModeChange('bubble');
            }}
            style={{
              background: mode === 'bubble' ? 'linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.85))' : 'linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
              border: mode === 'bubble' ? '1px solid rgba(255,255,255,0.4)' : '1px solid rgba(255,255,255,0.2)',
              color: mode === 'bubble' ? '#000' : 'white',
              padding: '6px 12px',
              borderRadius: '16px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              minWidth: '60px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: mode === 'bubble' ? '0 2px 8px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.3)' : '0 1px 4px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            title="Single View Mode"
          >
            Single
          </button>
          {quadView&&(
             <button 
             onClick={() => {
               console.log('Quad view button clicked');
               onModeChange('quad');
             }}
             style={{
               background: mode === 'quad' ? 'linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.85))' : 'linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
               border: mode === 'quad' ? '1px solid rgba(255,255,255,0.4)' : '1px solid rgba(255,255,255,0.2)',
               color: mode === 'quad' ? '#000' : 'white',
               padding: '6px 12px',
               borderRadius: '16px',
               cursor: 'pointer',
               fontSize: '12px',
               fontWeight: '600',
               transition: 'all 0.3s ease',
               minWidth: '60px',
               height: '28px',
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               boxShadow: mode === 'quad' ? '0 2px 8px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.3)' : '0 1px 4px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.1)',
               position: 'relative',
               overflow: 'hidden'
             }}
             title="Quad View Mode"
           >
             Quad
           </button>

          )}
         
        </div>
        ) 
      }
      
      {presets && presets.length > 0 && selectDropDown && (
        <select 
          onChange={(e) => {
            const preset = presets.find(p => p.id === e.target.value);
            if (preset) onPreset(preset);
          }}
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.2)',
            color: 'white',
            padding: '6px 10px',
            borderRadius: '16px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            minWidth: '80px',
            height: '28px',
            outline: 'none',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            marginLeft: '8px'
          }}
        >
          <option value="">Select View</option>
          {presets.map(preset => (
            <option key={preset.id} value={preset.id} style={{color: 'black'}}>
              {preset.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
